const messages = {
  logout: '로그아웃',
  help: 'T-K'
}

export default messages
